import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import { Provider } from "react-redux";
// import { ThemeProvider } from "@mui/material/styles";
// import {
// 	Experimental_CssVarsProvider as CssVarsProvider,
// 	experimental_extendTheme as extendTheme,
// 	ThemeProvider,
// } from "@mui/material/styles";
// import CssBaseline from "@mui/material/CssBaseline";
// import { AppProvider } from "./provider/AppProvider";
// import { AuthProvider } from "./authentication/AuthContext";
// import { BrowserRouter } from "./provider/BrowserRouter";
// import { MuiTheme } from "./@setting";
// import { GlobalStyles } from "@mui/system";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
